import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";

import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { SignatureService } from "src/app/mon-portefeuille/core/service/signature.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { OfficeViewerModalComponent } from "../../modal/viewer/office-viewer-modal/office-viewer-modal.component";
import { PdfViewerModalComponent } from "../../modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component";
import { ImageViewerModalComponent } from "../../modal/viewer/image-viewer-modal/image-viewer-modal.component";
import { DocViewerModalComponent } from "../../modal/viewer/doc-viewer-modal/doc-viewer-modal.component";
import { TaskDocumentService } from "src/app/parametrage/core/service/task-document.service";
import { TaskDocument } from "src/app/parametrage/core/model/task-document";

@Component({
  selector: "app-form-signer-rapport-emission-avis",
  templateUrl: "./form-signer-rapport-emission-avis.component.html",
  styleUrls: ["./form-signer-rapport-emission-avis.component.scss"],
})
export class FormSignerRapportEmissionAvisComponent implements OnInit {
  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  fichiers: SubItemCheckedDTO[];
  formulaireSignature: FormulaireDTO;

  documents: TaskDocument[];
  documentsObligatoire: TaskDocument[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService,
    private _gestionFichierService: GestionFichierService,
    private _signatureService: SignatureService,
    private _taskDocumentService: TaskDocumentService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      avis: [null, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
      this.getTaskDocumentsNotUploadedByTaskId(this.taskId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getTaskDocumentsNotUploadedByTaskId(taskId) {
    this._taskDocumentService
      .getTaskDocumentsNotUploadedByTaskId(taskId)
      .subscribe(
        (data) => {
          this.documents = data.sort((a, b) => (a.label > b.label ? 1 : -1));
          this.documentsObligatoire = this.documents.filter(
            (t) => t.obligatoire == true
          );
          if (this.documents.length == 1) {
            this.getRapportsClient(this.requestId, this.documents[0].code);
          } else {
            this.getRapportsClient(this.requestId, "_");
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getRapportsClient(requestId, filenameWithoutExtension) {
    this._gestionFichierService
      .getRapportsClient(requestId, filenameWithoutExtension)
      .subscribe(
        (data) => {
          this.fichiers = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  signer(subItemId) {
    this._signatureService.downloadFileAndRedirectUrl(subItemId).subscribe(
      (data) => {
        this.formulaireSignature = data;
        window.open(this.formulaireSignature.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }

  /** */

  fileViewer(subitem: SubItem): void {
    const fileTab = subitem.name.split(".");
    const fileExtension = fileTab[fileTab.length - 1];

    if (fileExtension.toLowerCase() == "pdf") {
      this.pdfViewer(subitem.id);
    } else if (
      fileExtension.toLowerCase() == "png" ||
      fileExtension.toLowerCase() == "jpeg" ||
      fileExtension.toLowerCase() == "jpg"
    ) {
      this.imageViewer(subitem.id);
    } else {
      this.officeViewer(subitem.id);
    }
  }

  officeViewer(subitemId): void {
    const modalRef = this.modalService.open(OfficeViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  imageViewer(subitemId): void {
    const modalRef = this.modalService.open(ImageViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  docViewer(subitemId): void {
    const modalRef = this.modalService.open(DocViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
